import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "session" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "preview-container" }
const _hoisted_6 = {
  key: 0,
  class: "empty-box"
}
const _hoisted_7 = {
  key: 1,
  class: "preview-box",
  ref: "previewBoxRef"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "btn-list" }
const _hoisted_10 = ["onMousedown", "onMousemove", "onMouseup"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "setting-container" }
const _hoisted_13 = {
  key: 0,
  class: "preview-item"
}
const _hoisted_14 = {
  key: 0,
  class: "preview-item"
}
const _hoisted_15 = { class: "action-list" }

import { getCurrentInstance, ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getSceneListApi, saveSceneApi, delSceneApi } from '@/apis/house'
import { beforeUpload, fileUpload } from '@/utils/upload'
import { Plus, Delete } from '@element-plus/icons-vue'
import { getImgInfo } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'SceneDetail',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const route = useRoute()

const { id: scene_id, name } = route.query

const previewList = ref<string[]>([]) // 预览图片列表

const sceneList = ref<any>([]) // 场景列表
const emptyScene = { // 空场景
    scene_id, // 场景
    master_item_img: '', // 场景背景图
    scene_item_data: [ // 按钮元素列表
        {
            goods_img: '', // 按钮图标
            goods_url: '', // 按钮跳转地址
            position: { // 按钮位置坐标
                left: 0,
                top: 0
            },
            width: 0, // 图片宽度
            height: 0, // 图片高度
            type: 'add' // 操作类型：add-新增，up-更新，del-删除
        }
    ]
}
const activeIndex = ref(0) // 当前选中的场景索引
const activeScene = ref<any>({}) // 当前选中的场景
const getThemeInfo = async () => {
    const { code, data, msg } = await getSceneListApi(scene_id as string) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    if (data.length) {
        sceneList.value = data
        activeScene.value = data[activeIndex.value]
    } else {
        sceneList.value = [JSON.parse(JSON.stringify(emptyScene))]
        activeScene.value = JSON.parse(JSON.stringify(emptyScene))
    }
}
getThemeInfo()

// 切换场景
const onTabChange = (index) => {
    activeIndex.value = index
    activeScene.value = sceneList.value[index]
}

/**************************** 拖拽 -- begin ****************************/
const startX = ref(0)
const startY = ref(0)
const isDragging = ref(false)
const startDragging = (e, index) => {
    isDragging.value = true;
    startX.value = e.clientX - activeScene.value.scene_item_data[index].position.left
    startY.value = e.clientY - activeScene.value.scene_item_data[index].position.top
}
const dragging = (e, index) => {
    if (isDragging.value) {
        activeScene.value.scene_item_data[index].position.left = e.clientX - startX.value
        activeScene.value.scene_item_data[index].position.top = e.clientY - startY.value
    }
}
const stopDragging = (e, index) => {
    isDragging.value = false;
}
/**************************** 拖拽 -- end ****************************/


/**************************** 图片上传、校验、删除 -- begin ****************************/
/**
 * 图片上传前校验
 *  index: -1 入口图, 其他为列表图片
 */
const onBeforeUpload = (file, index) => {
    if (index === -1) {
        return beforeUpload(file, { size: 900, width: 750 })
    } else {
        return beforeUpload(file, { size: 200 })
    }
}
/**
 * 图片上传
 *  param: 
 *      上传文件
 *  index: 
 *      -1：入口图；其他数字：主题列表索引
 *  type:
 *      icon：图标, selected_icon：选中图标
 */
const onUploadSuccess = async (param:any, index:number) => {
    const { code, data, msg } = await fileUpload(param.file, {folderName: 'scene'}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    const { url } = data

    if (index === -1) {
        activeScene.value.master_item_img = url
    } else {
        activeScene.value.scene_item_data[index].goods_img = url
        const { width, height } = await getImgInfo(param.file) as any
        activeScene.value.scene_item_data[index].width = width
        activeScene.value.scene_item_data[index].height = height
    }
}
/**
 * 图片删除
 *  index:
 *      -1：入口图, 其他数字：主题列表索引
 *  type:
 *      icon：图标, selected_icon：选中图标
 * */
const onImgRemove = (index:number) => {
    index === -1 ? activeScene.value.master_item_img = '' : activeScene.value.scene_item_data[index].goods_img = ''
}
/**************************** 图片上传、校验、删除 -- end ****************************/


/**************************** 按钮新增、删除 -- begin ****************************/
// 新增按钮
const onAddBtn = () => {
    activeScene.value.scene_item_data.push(JSON.parse(JSON.stringify(emptyScene.scene_item_data[0])))
}
// 删除按钮
const onDelBtn = (index: number) => {
    proxy.$confirm(`确定要删除该行`, '提示', {
        type: 'warning'
    }).then(() => {
        activeScene.value.scene_item_data.filter(item => item.type != 'del')[index].type = 'del'
        if (activeScene.value.scene_item_data.filter(item => item.type !== 'del').length === 0) {
            activeScene.value.scene_item_data = JSON.parse(JSON.stringify(emptyScene.scene_item_data))
        }
    }).catch(() => {
        console.log('取消删除')
    })
}
/**************************** 按钮新增、删除 -- end ****************************/


/**************************** 场景新增、保存、删除 -- begin ****************************/
// 检查数据
const checkData = () => {
    let result = true
    if (!activeScene.value.master_item_img) {
        proxy.$message({ type: 'error', message: '请上传入口图' })
        return false
    }

    activeScene.value.scene_item_data = activeScene.value.scene_item_data.filter(item => item.id || (!item.id && item.type !== 'del' && (item.goods_img || item.goods_url))) // 新增的数据，如果删除了，则不保存
    activeScene.value.scene_item_data.map((item, index) => {
        if (item.type !== 'del' && (!item.goods_url || !item.goods_img)) {
            if (!item.goods_img) {
                proxy.$message({ type: 'error', message: `请添加图标` })
                result = false
                return
            }
            if (!item.goods_url) {
                proxy.$message({ type: 'error', message: `请添加跳转链接` })
                result = false
                return
            }
        }
    })

    return result
}
// 保存场景
const onSave = async () => {
    if (!checkData()) { return }

    const { code, data, msg } = await saveSceneApi({ scene_id, ...activeScene.value }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    proxy.$message({ type: 'success', message: '操作成功' })
    getThemeInfo()
}
// 新增场景
const onAddScene = () => {
    activeScene.value = JSON.parse(JSON.stringify(emptyScene))
    sceneList.value.push(activeScene.value)
    activeIndex.value = sceneList.value.length - 1
}
// 删除场景
const onDelScene = () => {
    proxy.$confirm(`确定要删除该场景`, '提示', {
        type: 'warning'
    }).then(() => {
        if (!activeScene.value.id) { // 新增的数据，直接删除
            sceneList.value.splice(activeIndex.value, 1)
            activeIndex.value = activeIndex.value == 0 ? 0 : activeIndex.value - 1
            getThemeInfo()
            return
        } else {
            delSceneApi(activeScene.value.id).then((res: any) => {
                if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
                proxy.$message({ type: 'success', message: '操作成功' })
                activeIndex.value = activeIndex.value == 0 ? 0 : activeIndex.value - 1
                getThemeInfo()
            })
        }
    }).catch(() => {
        console.log('取消删除')
    })
}
/**************************** 场景新增、保存、删除 -- end ****************************/

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_unref(name)), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass({ active: index === activeIndex.value }),
            key: index,
            onClick: ($event: any) => (onTabChange(index))
          }, _toDisplayString(`场景${index+1}>>`), 11, _hoisted_4))
        }), 128)),
        _createElementVNode("li", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            round: "",
            size: "small",
            onClick: onAddScene
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("+新增场景")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!activeScene.value.master_item_img)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                src: activeScene.value.master_item_img,
                alt: "bg"
              }, null, 8, _hoisted_8),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeScene.value.scene_item_data.filter(item => item.goods_img), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "img-container",
                    key: index,
                    onMousedown: _withModifiers(($event: any) => (startDragging($event, index)), ["prevent"]),
                    onMousemove: _withModifiers(($event: any) => (dragging($event, index)), ["prevent"]),
                    onMouseup: _withModifiers(($event: any) => (stopDragging($event, index)), ["prevent"]),
                    style: _normalizeStyle({ left: item.position.left + 'px', top: item.position.top + 'px' })
                  }, [
                    _createElementVNode("img", {
                      style: _normalizeStyle({ width: (item.width/2) + 'px', height: (item.height/2) + 'px' }),
                      src: item.goods_img
                    }, null, 12, _hoisted_11)
                  ], 44, _hoisted_10))
                }), 128))
              ])
            ], 512)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "color6 mt10" }, "注意：可拖动按钮调整位置", -1)),
        _createVNode(_component_el_row, { class: "mt20" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: onDelScene
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("删除场景")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onSave
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("保存")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "主题图：" }, {
              default: _withCtx(() => [
                (activeScene.value.master_item_img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_image, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (previewList.value = [activeScene.value.master_item_img])),
                        src: activeScene.value.master_item_img,
                        "preview-src-list": previewList.value,
                        "hide-on-click-modal": ""
                      }, null, 8, ["src", "preview-src-list"]),
                      _createVNode(_component_el_icon, {
                        class: "delete-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onImgRemove(-1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Delete))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_el_upload, {
                      key: 1,
                      class: "el-upload-list__item empty-item",
                      accept: ".jpg,.jpeg,.png",
                      action: "none",
                      "before-upload": file => onBeforeUpload(file, -1),
                      "http-request": file => onUploadSuccess(file, -1),
                      "list-type": "picture-card",
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["before-upload", "http-request"])),
                _cache[6] || (_cache[6] = _createElementVNode("div", {
                  class: "color-danger",
                  style: {"width":"100%"}
                }, "注：建议尺寸 750*1500，须小于900k", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: activeScene.value.scene_item_data?.filter(row => row.type !== 'del'),
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "按钮图标",
                      width: "124"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.goods_img)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_el_image, {
                                onClick: ($event: any) => (previewList.value = [scope.row.goods_img]),
                                src: scope.row.goods_img,
                                "preview-src-list": previewList.value,
                                fit: "scale-down",
                                "hide-on-click-modal": "",
                                "preview-teleported": true
                              }, null, 8, ["onClick", "src", "preview-src-list"]),
                              _createVNode(_component_el_icon, {
                                class: "delete-icon",
                                onClick: ($event: any) => (onImgRemove(scope.$index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Delete))
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          : (_openBlock(), _createBlock(_component_el_upload, {
                              key: 1,
                              class: "el-upload-list__item empty-item",
                              accept: ".jpg,.jpeg,.png,.gif",
                              action: "uploadUrl",
                              "before-upload": file => onBeforeUpload(file, scope.$index),
                              "http-request": file => onUploadSuccess(file, scope.$index),
                              "list-type": "picture-card",
                              "show-file-list": false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Plus))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["before-upload", "http-request"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "链接" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.goods_url,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.goods_url) = $event),
                          placeholder: "请输入链接"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      width: "80"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (onDelBtn(scope.$index))
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("删除")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_row, {
                  style: {"width":"100%"},
                  class: "mt10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: onAddBtn
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("新增按钮")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})